export default {"src":"/_next/static/media/upload1.623755c4.svg","height":76,"width":76,"blurWidth":0,"blurHeight":0};